import { useGateways } from "core/gateways-context/useGateways";
import { UserDto } from "core/types";

import { useAccount } from "@azure/msal-react";
import { HttpError } from "@bps/http-client";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { UserPreferenceArgs, UserPreferenceModel } from "./user.dtos";

export enum UserCacheKeys {
  Profile = "user-profile",
  Preferences = "user-preferences"
}

export const useCurrentUserQuery = (): UseQueryResult<UserDto> => {
  const account = useAccount();
  const { userApi } = useGateways();

  return useQuery<UserDto, HttpError>({
    queryKey: [UserCacheKeys.Profile],
    queryFn: userApi.getCurrentUser,
    enabled: !!account,
    staleTime: Infinity,
    gcTime: Infinity
  });
};

export const useUserPreferencesQuery = () => {
  const { userApi } = useGateways();

  const args: UserPreferenceArgs = {
    names: ["AppointmentLength"]
  };
  return useQuery<UserPreferenceModel[], unknown>({
    queryKey: [UserCacheKeys.Preferences],
    queryFn: async () => await userApi.getUserPreferences(args)
  });
};
